import { sendRecoveryEmail as universalSendRecoveryEmail, sendActivationEmail as universalSendActivationEmail, recover as universalRecover, } from './iam-recovery-v1-recovery-recovery.universal';
export const __metadata = { PACKAGE_NAME: '@wix/identity' };
export function sendRecoveryEmail(httpClient) {
    return (email, options) => universalSendRecoveryEmail(email, options, 
    // @ts-ignore
    { httpClient });
}
export function sendActivationEmail(httpClient) {
    return (identityId, options) => universalSendActivationEmail(identityId, options, 
    // @ts-ignore
    { httpClient });
}
export function recover(httpClient) {
    return (recoveryToken, options) => universalRecover(recoveryToken, options, 
    // @ts-ignore
    { httpClient });
}
export { TenantType, StateType, PrivacyStatus, EmailTag, PhoneTag, AddressTag, StatusName, Reason, } from './iam-recovery-v1-recovery-recovery.universal';
//# sourceMappingURL=iam-recovery-v1-recovery-recovery.public.js.map